/* One native Shopify signup, progressively presented as a non-modal welcome card. */
(function () {
  'use strict';
  if (window.__alpWelcomeV1) return;
  window.__alpWelcomeV1 = true;

  var mounts = new Map();
  var shownKey = 'alp_welcome_last_shown_v2';
  var legacyDismissedKey = 'alp_welcome_dismissed_v1';
  var subscribedKey = 'alp_welcome_subscribed_v1';
  var readyAt = null;
  var runtimeShown = 0;
  var runtimeSubscribed = false;
  var activeController = null;

  function readStorage(name, key) {
    try { return window[name].getItem(key); } catch (error) { return null; }
  }
  function writeStorage(name, key, value) {
    try { window[name].setItem(key, String(value)); } catch (error) { /* Browsing remains available with storage disabled. */ }
  }
  function isVisible(element) {
    if (!element || element.hidden) return false;
    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
  }
  function isField(element) {
    return !!(element && element.matches && element.matches('input, textarea, select, [contenteditable]:not([contenteditable="false"])'));
  }
  function hasBlockingOverlay() {
    if (document.querySelector('dialog[open]')) return true;
    var candidates = document.querySelectorAll('[aria-modal="true"], [role="dialog"], .mobile-menu--opened, .ajax-cart__drawer, .ajax-cart__popover, .cart-drawer, .mini-cart, .fancybox-container');
    return Array.prototype.some.call(candidates, isVisible);
  }

  function mount(root) {
    if (mounts.has(root)) return;
    var card = root.querySelector('[data-alp-welcome]');
    var slot = root.querySelector('[data-alp-welcome-slot]');
    var launch = slot && slot.querySelector('[data-alp-welcome-launch]');
    if (!card || !slot || !launch) return;

    var closeButton = card.querySelector('[data-alp-welcome-close]');
    var email = card.querySelector('input[type="email"]');
    var result = card.querySelector('[data-alp-welcome-result]');
    var resultState = result && result.getAttribute('data-alp-welcome-result');
    var hideDays = Math.max(1, Number(card.dataset.hideDays) || 7);
    var eligible = card.dataset.autoEligible === 'true';
    var openState = false;
    var manualTrigger = null;
    var disposed = false;
    var suspended = false;
    var autoTimer = 0;
    var frame = 0;
    var dockObserver = null;
    var dockNodes = [];
    var cleanupListeners = [];

    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      cleanupListeners.push(function () { target.removeEventListener(type, handler, options); });
    }
    function timestamp(value) {
      var number = Number(value);
      return Number.isFinite(number) && number > 0 ? number : 0;
    }
    function lastShown() {
      var local = timestamp(readStorage('localStorage', shownKey));
      var legacy = timestamp(readStorage('localStorage', legacyDismissedKey));
      if (legacy > local) writeStorage('localStorage', shownKey, legacy);
      return Math.max(runtimeShown, local, legacy, timestamp(readStorage('sessionStorage', shownKey)));
    }
    function markShown() {
      runtimeShown = Date.now();
      writeStorage('localStorage', shownKey, runtimeShown);
      writeStorage('sessionStorage', shownKey, runtimeShown);
    }
    function markSubscribed() {
      runtimeSubscribed = true;
      writeStorage('localStorage', subscribedKey, '1');
      writeStorage('sessionStorage', subscribedKey, '1');
    }
    function isSubscribed() {
      return runtimeSubscribed || readStorage('localStorage', subscribedKey) === '1' || readStorage('sessionStorage', subscribedKey) === '1';
    }
    function queueAuto(delay) {
      window.clearTimeout(autoTimer);
      autoTimer = 0;
      if (disposed || suspended || openState) return;
      autoTimer = window.setTimeout(attemptAuto, Math.min(2147483647, Math.max(0, delay)));
    }
    function viewport() {
      var visual = window.visualViewport;
      var height = visual ? visual.height : window.innerHeight;
      var bottom = visual ? Math.max(0, window.innerHeight - visual.height - visual.offsetTop) : 0;
      card.style.setProperty('--alp-welcome-viewport-height', Math.round(height) + 'px');
      card.style.setProperty('--alp-welcome-viewport-bottom', Math.round(bottom) + 'px');
    }
    function holdDock() {
      if (!openState) return;
      document.querySelectorAll('[data-alp-dock]').forEach(function (dock) {
        if (dockNodes.indexOf(dock) < 0) {
          dockNodes.push(dock);
          if (dockObserver) dockObserver.observe(dock, { attributes: true, attributeFilter: ['aria-hidden', 'inert', 'class'] });
        }
        if (dock.getAttribute('aria-hidden') !== 'true') dock.setAttribute('aria-hidden', 'true');
        if (!dock.hasAttribute('inert')) dock.setAttribute('inert', '');
      });
    }
    function releaseDock() {
      if (dockObserver) dockObserver.disconnect();
      dockObserver = null;
      dockNodes.forEach(function (dock) {
        var visible = dock.classList.contains('is-visible');
        dock.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (visible) dock.removeAttribute('inert'); else dock.setAttribute('inert', '');
      });
      dockNodes = [];
    }
    function emitState(open) {
      document.dispatchEvent(new CustomEvent('alp:welcome-toggle', { detail: { open: open } }));
    }
    function open(mode, trigger) {
      if (disposed || (mode !== 'result' && hasBlockingOverlay())) return false;
      if (activeController && activeController !== controller) activeController.close();
      if (openState) {
        if (mode === 'manual') (email || closeButton || card).focus({ preventScroll: true });
        return true;
      }
      manualTrigger = mode === 'manual' ? trigger : null;
      openState = true;
      activeController = controller;
      window.clearTimeout(autoTimer);
      autoTimer = 0;
      viewport();
      card.hidden = false;
      card.classList.add('alp-welcome--open');
      markShown();
      document.documentElement.classList.add('alp-welcome-open');
      var image = card.querySelector('[data-alp-welcome-image]');
      if (image) image.loading = 'eager';
      dockObserver = new MutationObserver(holdDock);
      if (document.body) dockObserver.observe(document.body, { childList: true });
      holdDock();
      emitState(true);
      if (mode === 'manual') (email || closeButton || card).focus({ preventScroll: true });
      return true;
    }
    function close() {
      if (!openState) return;
      var returnFocus = manualTrigger && card.contains(document.activeElement) && document.contains(manualTrigger);
      openState = false;
      card.hidden = true;
      card.classList.remove('alp-welcome--open');
      if (activeController === controller) {
        activeController = null;
        document.documentElement.classList.remove('alp-welcome-open');
      }
      releaseDock();
      emitState(false);
      if (returnFocus) manualTrigger.focus({ preventScroll: true });
      manualTrigger = null;
      if (!disposed) scheduleAttempt();
    }
    function attemptAuto() {
      window.clearTimeout(autoTimer);
      autoTimer = 0;
      if (disposed || suspended || openState || !eligible || (window.Shopify && window.Shopify.designMode) || isSubscribed()) return;
      var readyDelay = 2000 - (Date.now() - readyAt);
      if (readyDelay > 0) { queueAuto(readyDelay); return; }
      var shown = lastShown();
      var repeatDelay = shown > 0 ? shown + hideDays * 86400000 - Date.now() : 0;
      if (repeatDelay > 0) { queueAuto(repeatDelay); return; }
      if (document.hidden) return;
      var focusedDock = document.activeElement && document.activeElement.closest && document.activeElement.closest('[data-alp-dock]');
      if (isField(document.activeElement) || hasBlockingOverlay() || focusedDock) { queueAuto(1000); return; }
      if (!open('auto')) queueAuto(1000);
    }
    function scheduleAttempt() {
      if (frame || disposed || suspended) return;
      frame = window.requestAnimationFrame(function () { frame = 0; attemptAuto(); });
    }
    function onClick(event) {
      var target = event.target && event.target.closest ? event.target : null;
      if (!target) return;
      var trigger = target.closest('[data-alp-welcome-open]');
      if (trigger && root.contains(trigger)) {
        if (open('manual', trigger)) event.preventDefault();
        return;
      }
      if (target.closest('[data-alp-welcome-close]') && card.contains(target)) close();
    }
    function onKey(event) {
      if (event.key === 'Escape' && openState && card.contains(event.target)) {
        event.preventDefault();
        close();
      }
    }

    var controller = { close: close, dispose: function () {
      if (disposed) return;
      disposed = true;
      window.clearTimeout(autoTimer);
      window.cancelAnimationFrame(frame);
      cleanupListeners.forEach(function (cleanup) { cleanup(); });
      close();
      slot.insertBefore(card, launch);
      card.hidden = false;
      card.classList.remove('is-enhanced');
      launch.hidden = true;
      card.style.removeProperty('--alp-welcome-viewport-height');
      card.style.removeProperty('--alp-welcome-viewport-bottom');
      mounts.delete(root);
    } };
    mounts.set(root, controller);
    root.appendChild(card);
    card.classList.add('is-enhanced');
    card.hidden = true;
    launch.hidden = false;
    listen(root, 'click', onClick);
    listen(root, 'keydown', onKey);
    listen(window, 'pagehide', function () {
      suspended = true;
      manualTrigger = null;
      close();
      window.clearTimeout(autoTimer);
      autoTimer = 0;
      window.cancelAnimationFrame(frame);
      frame = 0;
    });
    listen(window, 'pageshow', function () {
      suspended = false;
      scheduleAttempt();
    });
    listen(window, 'resize', function () { viewport(); scheduleAttempt(); }, { passive: true });
    listen(document, 'visibilitychange', scheduleAttempt);
    listen(document, 'focusout', scheduleAttempt);
    if (window.visualViewport) {
      listen(window.visualViewport, 'resize', viewport, { passive: true });
      listen(window.visualViewport, 'scroll', viewport, { passive: true });
    }
    if (resultState === 'success') markSubscribed();
    if (resultState === 'success' || resultState === 'error') open('result');
    else queueAuto(Math.max(0, 2000 - (Date.now() - readyAt)));
  }

  function boot(scope) {
    if (readyAt === null) readyAt = Date.now();
    if (scope.matches && scope.matches('[data-alp-home]')) mount(scope);
    scope.querySelectorAll('[data-alp-home]').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    mounts.forEach(function (controller, root) { if (event.target === root || event.target.contains(root)) controller.dispose(); });
  });
})();
